import { all, call, put, takeLatest } from "redux-saga/effects";
import { fetchCmsDataForNodes } from "@/api/cms";
import { setCmsData, setCmsError, setCmsLoading } from "./cmsSlice";

const pageNodes = [
  "home",
  "pdp",
  "srp",
  "bidWizard",
  "offerWizard",
  "faqSection",
  "myaccounts",
  "identityVerification",
  "discover",
  "mypurchaseprofile",
  "proxybidregistration",
  "discover__",
  "faqSectionCopy",
  "loginSignup",
  "userDashboard",
  "crypto",
  "careers",
  "inTheNews",
  "cashIncentive",
  "sellCommercial",
  "sellResidential",
  "sellBroker",
  "cyberMonday",
  "terms",
];

const globalNodes = [
  "errorMessages",
  "appUpdateConfig",
  "shared",
  "aboutUsData",
];

function* fetchCmsSaga() {
  try {
    yield put(setCmsLoading());

    const [pagesData, globalData,loginData] = yield all([
      call(fetchCmsDataForNodes, "pages/home"),
      call(fetchCmsDataForNodes, "global"),
      call(fetchCmsDataForNodes, "pages/loginSignup"),
    ]);

    const merged = { ...pagesData, ...globalData,...loginData };
    yield put(setCmsData(merged));
  } catch (error) {
    yield put(setCmsError(error.message || "Failed to load CMS data"));
  }
}

export function* watchCmsSaga() {
  yield takeLatest("cms/fetchAll", fetchCmsSaga);
}
